import type { ShadbalaRequest, ShadbalaResponse } from "@ishvaram/api-client";
import { apiRequest } from "./_fetch";

export type { ShadbalaRequest, ShadbalaResponse };
export type { PlanetShadbalaRow } from "@ishvaram/api-client";

export async function calculateShadbala(data: ShadbalaRequest): Promise<ShadbalaResponse> {
  return apiRequest<ShadbalaResponse>("/shadbala", {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(data),
  });
}
